<template>
    <div>
        <div>
            <h4>
                {{restaurant.name}}
                <button class="mdl-button" v-on:click="loadTemplate()">Načíst šablonu</button>
                <!-- not used design for copy table as html object
                <button v-if="menu != null && (menuState === menuStates[2].id || menuState === menuStates[3].id)" class="mdl-button" v-on:click="exportData()">
                    Exportovat
                    <Modal :open-counter="this.openCounter" :title="`menu id=${this.menu.menuId}`">
                        <MenuSummaryDialog :menu-id="this.menu.menuId" ref="mydialog"></MenuSummaryDialog>
                    </Modal>
                </button>-->
                <span style="">
                    <button v-if="menu != null && (menuState === menuStates[2].id || menuState === menuStates[3].id)" class="mdl-button" v-on:click="copyAsText()">
                        Zkopírovat text tabulky
                    </button>
                    <span v-if="showBadge" class="mdl-badge mdl-badge--no-background" :data-badge="badgeContent" style="color: blue !important; position: relative !important; top: 0px; left:-18px; z-index: 10;"></span>
                    <span v-else style="margin-left: 24px">
                    </span>
                </span>
                
            </h4>

            <h6>Stav: <combo-box :options="menuStates" v-model="menuState" :value="menuState" v-on:click="autoLoaded = false"></combo-box></h6>

            <div v-if="menuState === menuStates[0].id || menuState === menuStates[1].id">
                <h6>Hlavní jídla</h6>
                <menu-edit-foods :foods="menu.foods" @save="save()"></menu-edit-foods>
                <h6>Polévky</h6>
                <menu-edit-soups :soups="menu.soups" @save="save" @reload="load()"></menu-edit-soups>
            </div>
            
            <menu-summary v-else-if="menu != null && (menuState === menuStates[2].id || menuState === menuStates[3].id)" :menu-id="this.menu.menuId"></menu-summary>
        </div>

        <snackbar :open-counter="snackbarCounter">
            <div>Úspěšně uloženo v {{ new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds() }}</div>
        </snackbar>
    </div>
</template>

<script>
    //import Modal from "./widgets/Modal";
    //import MenuSummaryDialog from "./MenuSummaryDialog";
    import axios from "axios";
    import config from "../config";
    import ComboBox from "./widgets/ComboBox";
    import Snackbar from "./widgets/Snackbar";
    import MenuSummary from "./MenuSummary";
    import MenuEditFoods from "./MenuEditFoods";
    import MenuEditSoups from "./MenuEditSoups";

    export default {
        name: "MenuEdit",
        components: {
            MenuEditSoups, MenuEditFoods, MenuSummary, Snackbar, ComboBox, /*Modal, MenuSummaryDialog*/},
        props: {
            restaurant: Object,
            day: String
        },
        data: function () {
            return {
                menu: null,
                soupModalOpen: 0,
                menuStates: [{ id:'NOT_READY', name: "Skryté"}, {id:'OPEN_FOR_ORDERS', name: "Otevřeno"}, {id:'CLOSED_FOR_ORDERS', name: "Objednáno"}, {id:'ARRIVED', name:"Dorazilo"}],
                snackbarCounter: 0,
                autoLoaded: true,
                showSummaryDialog: false,
                dialog: undefined,
                //openCounter: 0,
                foodsSummary: undefined,
                soupsSummary: undefined,
                showBadge: false,
                badgeColor: '#dd0000',
                badgeContent: '☻'
            }
        },
        methods: {
            /*exportData() {
                this.openCounter++;
            },*/

           async loadSummary() {
                const response = await axios
                    .get(config.host + "/v1/menu/summary/" + this.menu.menuId)
                if (response && response.data) {
                    this.foodsSummary = response.data.foods;
                    this.soupsSummary = response.data.soups;
                }
            },
            getOptionsName(options) {
                var name = ""
                var counter = 0
                for (const option of options) {
                    name += option.foodOptionType.name
                    counter++
                    if (counter < options.length) {
                        name += " + "
                    }
                }
                return name
            },

            async copyAsText() {
                await this.loadSummary()
                
                /*const range = document.createRange();
                range.setStart(this.$refs.tableContent,0);
                range.setEnd(this.$refs.tableContentFinish,0);
                let selection = window.document.getSelection()
                selection.addRange(range)
                let text = selection.toString()*/

                let text = "Hlavní jídla\r\n"
                text +=    "====================================================================================================\r\n"
                text += "Počet\tJméno\r\n" //Kód;\t
                text +=    "____________________________________________________________________________________________________\r\n"
                
                for (const foodItem of this.foodsSummary) {    
                    //text += foodItem.food.foodCode + ';\t'
                    text += foodItem.count + 'x\t'
                    text += foodItem.food.name + '\r\n'
                    
                    if (foodItem.foodOptions)
                        for (const option of foodItem.foodOptions) {
                            text += "\t( "+option.second +'x '+ this.getOptionsName(option.first) + ' )\r\n'
                        }
                    //text +=    "ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ \r\n"
                }

                text += "\r\n"
                text += "Polévky\r\n"
                text +=    "====================================================================================================\r\n"
                text += "Počet\tJméno\r\n" //Kód;\t
                text +=    "____________________________________________________________________________________________________\r\n"
                for (const soupItem of this.soupsSummary) {
                    //text += soupItem.first.soupCode + ';\t'
                    text += soupItem.second + 'x\t'
                    text += soupItem.first.name  + '\r\n'
                    //text +=    "ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ ˑ \r\n"
                }
                
                navigator.clipboard.writeText(text)
                .then(() => {
                    this.showBadge = true
                    this.badgeColor = '#00aa00'
                    this.badgeContent = '☻'
                    setTimeout(() => {
                        this.showBadge = false
                    }, 300);
                })
                .catch(err => {
                    this.showBadge = true
                    this.badgeColor = '#dd0000'
                    this.badgeContent = '!'
                    setTimeout(() => {
                        this.showBadge = false
                    }, 300);
                    // eslint-disable-next-line
                    console.error(err);
                });
            },

            load: function () {
                axios
                    .get(config.host + "/v1/menu/" + this.day + "/" + this.restaurant.restaurantId)
                    .then(response => {
                        this.menu = response.data;
                        this.$emit('onchange', this.menu.state);
                    })
                    // eslint-disable-next-line no-console
                    .catch(reason => console.log(reason));
            },
            loadTemplate: function () {
                axios
                    .get(config.host + "/v1/menu/template/" + this.restaurant.restaurantId + "/" + this.day)
                    .then(response => this.menu = response.data)
            },
            save: function () {
                if (JSON.stringify(this.menu).length > 2)
                    axios
                        .post(config.host + "/v1/menu/", this.menu)
                        // eslint-disable-next-line no-unused-vars
                        .then(response => {
                            this.load();
                            this.snackbarCounter++;
                        })
            },
        },
        computed: {
            menuState: {
                get: function() {
                    if(this.menu != null)
                        return this.menu.state;
                    return null;
                },
                set: function(value) {
                    this.menu.state = value;
                }
            },
            foods: function() {
                if(this.menu != null)
                    return this.menu.foods;
                return null;
            }
        },
        mounted() {
            this.load();
        },
        watch: {
            // eslint-disable-next-line
            day: function (newVal, oldVal) {
                //this.autoLoaded = true;
                this.load();
            },
            // eslint-disable-next-line
            restaurant:  function (newVal, oldVal) {
                //this.autoLoaded = true;
                this.load();
            },
            // eslint-disable-next-line
            menuState: function (newVal, oldVal) {
                //console.log("state changed to " + this.menu.state);
                if(this.autoLoaded)
                    this.autoLoaded = false;
                else
                    this.save();
            },
            // eslint-disable-next-line
            /*foods: function(oldVal, newVal) {
                console.log(newVal);
                //if(oldVal !== newVal)
                    //this.save();
            }*/
        }

    }
</script>

<style scoped>
    .even {
        background-color: #FAFAFA;
    }


    .mdl-chip__action {
        margin: 0;
    }

    .main-btn {
        float: right;
        color: white;
        margin-left: 1em
    }

    .mdl-badge.mdl-badge--no-background[data-badge]:after {
        color: v-bind('badgeColor')
    }
</style>